import React from "react";

import {
  t,
  HEADING1,
  HEADING2,
  HEADING3,
  HEADING4,
  CO,
  CO_LI1,
  CO_LI2,
  CO_LI3,
  CO_LI4,
  CO_LI5,
  CO_LI6,
  CO_LI7,
  CO_LI8,
  CO_LI9,
  CO_LI10,
  CO_LI11,
  CO_LI12,
  CO_LI13,
  CO_LI14,
  CO_LI15,
  CO_LI16,
  CO_LI17,
  CO_LI18,
  CO_LI19,
  CO_LI20,
  CO_LI21,
  CO_LI22,
  CO_LI23,
  CO_LI24,
  CO_LI25,
  CO_LI26,
  CO_LI27,
  CO_LI28,
  CO_LI29,
  CO_LI30,
  CO_LI31,
  CO_LI32,
  CO_LI33,
  DIV,
  DIV_LI1,
  DIV_LI2,
  DIV_LI3,
  DIV_LI4,
  DIV_LI5,
  DIV_LI6,
  DIV_LI7,
  DIV_LI8,
  DIV_LI9,
  DIV_LI10,
  DIV_LI11,
  DIV_LI12,
  DIV_LI13,
  DIV_LI14,
  DIV_LI15,
  DIV_LI16,
  DIV_LI17,
  DIV_LI18,
  DIV_LI19,
} from "../../translations/AboutUs/RtiAct";

function RtiAct() {
  return (
    <div
      style={{
        width: "80%",
        display: "flex",
        alignItems: "flex-start",
        justifyContent: "flex-start",
        flexDirection: "column",
        gap: 15,
        paddingRight: 10,
      }}
    >
      <div className="a-large" style={{ fontWeight: 600, textAlign: "left" }}>
        {t(HEADING1)}
      </div>
      <div className="a-normal" style={{ fontWeight: 500, textAlign: "left" }}>
        {t(HEADING2)}
      </div>
      <div className="a-normal" style={{ fontWeight: 500, textAlign: "left" }}>
        {t(HEADING3)}
      </div>
      <div className="a-normal" style={{ fontWeight: 600, textAlign: "left" }}>
        {t(HEADING4)}
      </div>
      <div className="a-normal" style={{ fontWeight: 600, textAlign: "left" }}>
        {t(CO)}
      </div>
      <ol style={{ margin: 0, padding: 0, marginLeft: 20 }}>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(CO_LI1)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(CO_LI2)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(CO_LI3)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(CO_LI4)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(CO_LI5)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(CO_LI6)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(CO_LI7)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(CO_LI8)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(CO_LI9)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(CO_LI10)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(CO_LI11)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(CO_LI12)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(CO_LI13)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(CO_LI14)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(CO_LI15)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(CO_LI16)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(CO_LI17)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(CO_LI18)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(CO_LI19)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(CO_LI20)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(CO_LI21)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(CO_LI22)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(CO_LI23)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(CO_LI24)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(CO_LI25)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(CO_LI26)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(CO_LI27)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(CO_LI28)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(CO_LI29)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(CO_LI30)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(CO_LI31)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(CO_LI32)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(CO_LI33)}</li>
      </ol>
      <div className="a-normal" style={{ fontWeight: 600, textAlign: "left" }}>
        {t(DIV)}
      </div>
      <ol style={{ margin: 0, padding: 0, marginLeft: 20 }}>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(DIV_LI1)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(DIV_LI2)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(DIV_LI3)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(DIV_LI4)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(DIV_LI5)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(DIV_LI6)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(DIV_LI7)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(DIV_LI8)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(DIV_LI9)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(DIV_LI10)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(DIV_LI11)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(DIV_LI12)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(DIV_LI13)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(DIV_LI14)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(DIV_LI15)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(DIV_LI16)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(DIV_LI17)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(DIV_LI18)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(DIV_LI19)}</li>
      </ol>
    </div>
  );
}

export default RtiAct;
